module.exports = __webpack_public_path__ + "img/zont.916e4334.jpg";